module.exports = __webpack_public_path__ + "img/TJ.8110e33b.png";